module.exports = __webpack_public_path__ + "static/img/cp_3.9532fda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cp_3.png
// module id = gQhE
// module chunks = 0